import {Alert, Button, Col, message, Row, Space} from "antd";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {FullPageLoader} from "../../../../../components/full-page-loader";
import {OfferingFormAccordionItem} from "../../../../../components/offering-form/accordion/accordion-item";
import {
  useSessionCoverImagesDelete,
  useSessionUploadCoverImages,
  useCoverImagesWithFallback,
  mapDomainToEmbedded,
} from "../../../../../features/media";
import {useCreateBundleContext} from "../../context/create-bundle";
import {useSession} from "../../../../../features/sessions";
import {SessionCoverImagesFormFields} from "../../../../../components/offering-form/session-bundle/session/cover-images";
import {CoverImagesItemResponse} from "../../../../../react-query-hooks/products/types";

export function CreateBundleCoverImagesUploadStep() {
  const bundleUploadCoverImagesMutation = useSessionUploadCoverImages();
  const bundleCoverImagesDeleteMutation = useSessionCoverImagesDelete();
  const {
    dispatch,
    state: {formData, apiResponseData},
  } = useCreateBundleContext();

  // Convert to number for useSession hook
  const bundleId = apiResponseData?.id ? Number(apiResponseData.id) : 0;
  const getBundleQuery = useSession(bundleId, bundleId > 0);

  // Convert Session entity coverImages to CoverImagesItemResponse[] for embedded fallback
  const embeddedCoverImages: CoverImagesItemResponse[] | undefined = getBundleQuery.data
    ? getBundleQuery.data.coverImages.map((img) => ({
        id: img.id,
        media_url: img.url,
        media_type: "image" as const,
        offering_id: getBundleQuery.data!.id,
        offering_type: "service" as const,
        user_id: getBundleQuery.data!.userId,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      }))
    : undefined;

  // v2 cover images fetch with embedded fallback
  const {coverImages, isLoading: isCoverImagesLoading} = useCoverImagesWithFallback({
    offeringType: "service",
    offeringId: getBundleQuery.data?.id,
    embedded: embeddedCoverImages,
  });
  const coverImagesForDisplay = mapDomainToEmbedded(coverImages);

  if (getBundleQuery.isLoading || isCoverImagesLoading) {
    return <FullPageLoader />;
  }

  if (getBundleQuery.isError) {
    return (
      <Alert
        message="Error"
        description={getBundleQuery.error.message}
        type="error"
        showIcon
      />
    );
  }
  function handleCoverImagesItemDelete({
    mediaId,
    offeringId,
  }: {
    mediaId: string;
    offeringId: number;
  }) {
    bundleCoverImagesDeleteMutation.mutate(
      {mediaId, offeringId},
      {
        onSuccess: () => {
          message.success("Deleted successfully");
        },
      }
    );
  }

  function handleNextStep() {
    dispatch({
      type: "update-create-bundle-form-step",
      payload: "automations",
    });
  }
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <OfferingFormAccordionItem key={"Cover image"} index={0} title={"Cover image"}>
          <SessionCoverImagesFormFields
            accordionIndex={0}
            sessionData={{
              id: getBundleQuery.data!.id,
            }}
            defaultCoverImages={coverImagesForDisplay}
            deleteCoverImage={handleCoverImagesItemDelete}
            isDeleteLoading={bundleCoverImagesDeleteMutation.isLoading}
            isUploadLoading={bundleUploadCoverImagesMutation.isLoading}
            offeringId={getBundleQuery.data!.id}
            uploadCoverImages={bundleUploadCoverImagesMutation}
          />
        </OfferingFormAccordionItem>
        <Row gutter={[0, 16]}>
          <Col span={24} sm={12}>
            <StyledServiceButtonWrapper>
              <Button
                onClick={() =>
                  dispatch({
                    type: "go-to-checkout-form-step",
                    payload: {
                      ...formData,
                    },
                  })
                }
                block
                size="small"
                type="default"
              >
                Back
              </Button>
              <Button
                block
                type="primary"
                size="small"
                onClick={handleNextStep}
                disabled={
                  bundleUploadCoverImagesMutation.isLoading ||
                  bundleCoverImagesDeleteMutation.isLoading
                }
              >
                Next
              </Button>
            </StyledServiceButtonWrapper>
          </Col>
        </Row>
      </Space>
    </div>
  );
}
